import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const prismaCloud = defineConnector({
  identifier: "prismaCloud",
  name: "Prisma Cloud",
  tagLine: "Cloud security posture management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api[^/]*\\.prismacloud\\.io/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `https://${app.config.apiUrl}/login`,
        jsonBody: {
          username: app.secret.accessKeyId,
          password: app.secret.secretKey,
        },
      },
      extract: { from: "jsonPath", paths: ["token"] },
      apply: { kind: "header", name: "x-redlock-auth" },
    }),
  steps: [
    {
      title: "Create an access key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Prisma Cloud](https://prismacloud.io), go to **Settings > Access Control > Access Keys** and create a new access key. Save the Access Key ID and Secret Key.",
        },
      ],
    },
    {
      title: "Enter your Prisma Cloud details",
      items: [
        {
          kind: "select",
          label: "API region",
          required: true,
          target: { kind: "configuration", field: "apiUrl" },
          options: [
            { value: "api.prismacloud.io", label: "US-1 (app.prismacloud.io)" },
            {
              value: "api2.prismacloud.io",
              label: "US-2 (app2.prismacloud.io)",
            },
            {
              value: "api3.prismacloud.io",
              label: "US-3 (app3.prismacloud.io)",
            },
            {
              value: "api.eu.prismacloud.io",
              label: "EU (app.eu.prismacloud.io)",
            },
            {
              value: "api.anz.prismacloud.io",
              label: "ANZ (app.anz.prismacloud.io)",
            },
            {
              value: "api.sg.prismacloud.io",
              label: "Singapore (app.sg.prismacloud.io)",
            },
            {
              value: "api.ind.prismacloud.io",
              label: "India (app.ind.prismacloud.io)",
            },
            {
              value: "api.jp.prismacloud.io",
              label: "Japan (app.jp.prismacloud.io)",
            },
            {
              value: "api.ca.prismacloud.io",
              label: "Canada (app.ca.prismacloud.io)",
            },
            {
              value: "api.uk.prismacloud.io",
              label: "UK (app.uk.prismacloud.io)",
            },
            {
              value: "api.fr.prismacloud.io",
              label: "France (app.fr.prismacloud.io)",
            },
            {
              value: "api.gov.prismacloud.io",
              label: "US-Gov (app.gov.prismacloud.io)",
            },
          ],
          helperText: "The Prisma Cloud API region for your tenant.",
        },
        {
          kind: "input",
          label: "Access key ID",
          required: true,
          target: { kind: "secrets", field: "accessKeyId" },
        },
        {
          kind: "input",
          label: "Secret key",
          required: true,
          target: { kind: "secrets", field: "secretKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiUrl }) => `https://${apiUrl}/check`,
  },
  publicEnvVars: ({ apiUrl }) => ({
    PRISMA_CLOUD_URL: apiUrl ? `https://${apiUrl}` : "",
  }),
});
